import {Negotiation} from "@/modules/diplomacy/entity";
import {injectable, multiInject} from "inversify";
import {TYPES} from "@/modules/diplomacy/types";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";

@injectable()
export class NegotiationCloser {
  constructor(
    @multiInject(TYPES.NegotiationCloser) private closers: NegotiationCloserInterface[],
  ) {}

  private async getCloser(negotiation: Negotiation) {
    const closer = await this.closers.findAsync<NegotiationCloserInterface>(async closer => closer.shouldRun(negotiation));

    if (!closer) {
      throw 'There is no closer for negotiation';
    }

    return closer;
  }

  public async can(negotiation: Negotiation) {
    return await (await this.getCloser(negotiation)).can(negotiation);
  }

  public async close(negotiation: Negotiation) {
    await (await this.getCloser(negotiation)).close(negotiation);
  }

  public async abort(negotiation: Negotiation) {
    await (await this.getCloser(negotiation)).abort(negotiation);
  }

  public async fail(negotiation: Negotiation) {
    await this.abort(negotiation);
  }
}